import {
  Button,
  Form,
  Input,
  notification,
  Select,
  Card,
  Modal,
  Drawer,
  Tag,
} from "antd";
import "moment/locale/vi"; // Import locale tiếng Việt
import { CloseOutlined, TagOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faHome,
  faMoneyBill,
  faMoneyBill1Wave,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import dayjs from "dayjs";
const ElectricityWaterBill = ({
  setLoading,
  loading,
  setStep,
  step,
  token,
}) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [supplierOpt, setSupplierOpt] = useState([]);
  const [recipient, setRecipient] = useState(null);
  const [visibleRecip, setVisibleRecip] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const [form] = Form.useForm();

  const applyVoucherPick = async (voucher) => {
    let amount = voucher.amountVoucher;
    if (voucher.discountType === "PERCENTAGE") {
      const amountDiscount = Math.ceil(
        recipient?.serviceItems[0]?.itemValue * (voucher.discountValue / 100)
      );
      amount =
        amountDiscount < voucher.maxDiscountValue
          ? amountDiscount
          : voucher.maxDiscountValue;
    }
    setVoucherValue(amount);
    setVoucherCode(voucher.code);
    setVoucherTxt(
      `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
  ${amount.toLocaleString("vi-VN")} đ</span></div>`
    );
    setOpenVoucher(false);
  };

  const getVouchers = async () => {
    setLoading(true);
    try {
      const res = await $axios.$post("/voucher/getVoucherByOrder", {
        Quantity: 1,
        Total: recipient?.serviceItems[0]?.itemValue,
      });
      const now = moment();
      const validVouchers = res.data.data.filter((voucher) => {
        const start = moment(voucher.startDate);
        const end = moment(voucher.endDate);
        return now.isBetween(start, end, null, "[]"); // [] để bao gồm cả thời gian bắt đầu và kết thúc
      });
      setVouchers(validVouchers);
      console.log(res, "res");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (recipient?.serviceItems?.length > 0) {
      getVouchers();
    }
  }, [recipient]);

  const handleCheckInvoice = async (values) => {
    console.log(values, "values");
    setLoading(true);
    try {
      const res = await $axios.$post(`payments/query-service`, values);
      if (!res.data.data?.recipientName) {
        notification.warning({
          status: "error",
          message: "Không tìm thấy hóa đơn!",
        });
        return;
      }
      setRecipient(res.data.data);
      setVisibleRecip(true);
    } catch (error) {
      notification.warning({
        status: "error",
        message: "Không tìm thấy hóa đơn!",
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async () => {
    setLoading(true);
    try {
      const body = {
        ServiceCode: form.getFieldValue("ServiceCode"),
        Recipient: form.getFieldValue("Recipient"),
        RecipientType: "",
        ReferCode: recipient?.referCode,
        ServiceItemReq: {
          ItemValue: recipient?.serviceItems[0]?.itemValue,
          ItemCode: recipient?.serviceItems[0]?.itemCode,
          Description: recipient?.serviceItems[0]?.description,
        },
        Quantity: 1,
        TotalAmount: recipient?.serviceItems[0]?.itemValue - voucherValue,
        VoucherCode: voucherCode,
        VoucherAmount: voucherValue,
        BillCode: "",
        InfoUsername: userInfo?.customerFullname || "",
        InfoPhone: userInfo?.phone || "",
        InfoEmail: userInfo?.email || "",
        VatMst: "",
        VatFullName: "",
        VatEmail: "",
      };
      const resPayment = await $axios.$post("/payments/paymentRequired", body);
      if (resPayment.data.data.paymentUrl) {
        window.location.href = resPayment.data.data.paymentUrl;
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      form.resetFields();
      setRecipient(null);
      getSupplierOpt();
    }
  }, [step, token]);

  const getSupplierOpt = async () => {
    try {
      const res = await $axios.$get(
        `/services/list?serviceSystem=${step === "electricity" ? 5 : 4}`
      );
      setSupplierOpt(res.data.data || []);
    } catch (error) {
      return null;
    }
  };

  return (
    <div className="flex flex-col items-center mt-[0px] step1 booking relative top-[100px]">
      <Form
        form={form}
        onFinish={handleCheckInvoice}
        layout="vertical"
        className="form-search w-[92%] mb-4"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 rounded-2xl"
          >
            <Form.Item
              name="Recipient"
              className="mb-4 flex-1"
              label={
                <div className="text-[16px] font-semibold mb-2">
                  Nhập mã khách hàng
                </div>
              }
              rules={[
                {
                  required: true,
                  message: "Mã khách hàng không được để trống",
                },
              ]}
              required
            >
              <Input
                placeholder="Nhập mã khách hàng"
                size="large"
                className="h-[46px] text-[16px]"
                allowClear
              />
            </Form.Item>

            <Form.Item
              label={
                <div className="text-[16px] font-semibold mb-2">
                  Chọn nhà cung cấp
                </div>
              }
              name={"ServiceCode"}
              rules={[
                {
                  required: true,
                  message: "Nhà cung cấp không được để trống",
                },
              ]}
              required
              className="mb-4"
            >
              <Select
                style={{ height: 46 }}
                size="large"
                placeholder="Chọn khu vực"
                notFoundContent="Không có dữ liệu"
                showSearch
                allowClear
              >
                {supplierOpt.map((item) => (
                  <Select.Option
                    key={item.serviceCode}
                    value={item.serviceCode}
                  >
                    {item.serviceName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Button
              type="primary"
              htmlType="sumit"
              loading={loading}
              style={{ height: 48 }}
              className="mb-4 w-full bg-primary"
            >
              <span className="text-[16px] font-bold">Kiểm tra hóa đơn</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
        <div className="text-center my-4">
          <span className="text-[#808080] font-normal">
            Hotline hỗ trợ khách hàng{" "}
          </span>
          <a
            href="tel:1900255585"
            className="font-bold text-primary text-[16px]"
          >
            1900255585
          </a>
        </div>
      </Form>

      <Modal
        closeIcon={null}
        title={
          <div className="flex gap-2 items-center px-4">
            <div>
              <div className="text-[16px] font-bold text-primary">
                Thông tin hóa đơn
              </div>
              <div className="text-[12px] font-medium italic">
                Vui lòng kiểm tra kĩ trước khi thanh toán
              </div>
            </div>
          </div>
        }
        open={visibleRecip}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        centered
        maskClosable={false}
        styles={{
          content: {
            padding: 0,
          },
          header: {
            padding: 6,
            paddingTop: 10,
          },
        }}
        footer={null}
        header={null}
      >
        {recipient && (
          <>
            <Card
              bodyStyle={{
                padding: "16px",
                backgroundColor: "#f9fafb",
                borderRadius: "8px",
              }}
            >
              <div className="flex gap-4 p-2 rounded-lg mb-2 items-center">
                <FontAwesomeIcon icon={faUser} />
                <div className="flex flex-col">
                  <div className="font-semibold text-[16px]">
                    Tên khách hàng
                  </div>
                  <div className="font-semibold text-[16px]">
                    {recipient.recipientName}
                  </div>
                </div>
              </div>
              <div className="flex gap-4  p-2 rounded-lg mb-2 items-center">
                <FontAwesomeIcon icon={faHome} />
                <div className="flex flex-col">
                  <div className="font-semibold text-[16px]">Địa chỉ</div>
                  <div className="font-semibold text-[16px]">
                    {recipient.recipientAddress}
                  </div>
                </div>
              </div>
              {voucherValue > 0 && (
                <div className="flex gap-4  p-2 rounded-lg items-center">
                  <FontAwesomeIcon icon={faMoneyBill1Wave} />
                  <div className="flex flex-col">
                    <div className="font-semibold text-[16px]">Giảm giá</div>
                    <div className="font-semibold text-[16px] text-green-500">
                      {voucherValue.toLocaleString("vi-VN")} đ
                    </div>
                  </div>
                </div>
              )}
              <div className="flex gap-4  p-2 rounded-lg items-center">
                <FontAwesomeIcon icon={faMoneyBill} />
                <div className="flex flex-col">
                  <div className="font-semibold text-[16px]">Tổng tiền</div>
                  <div className="font-semibold text-[16px]">
                    {(
                      recipient?.serviceItems[0]?.itemValue - voucherValue
                    ).toLocaleString("vi-VN")}{" "}
                    đ
                  </div>
                </div>
              </div>
            </Card>

            <div className=" bg-white p-4 text-[#0D1634] my-3">
              <div className="flex justify-between">
                <span className="font-semibold">Mã khuyến mãi</span>
                <div className="flex">
                  <Tag
                    onClick={() => setOpenVoucher(true)}
                    color={
                      voucherCode === "" && voucherValue === 0
                        ? "default"
                        : "success"
                    }
                    icon={<TagOutlined />}
                  >
                    {voucherCode === "" && voucherValue === 0
                      ? "Chọn mã giảm giá"
                      : voucherCode}
                  </Tag>
                  {voucherCode !== "" && voucherValue > 0 && (
                    <CloseOutlined
                      style={{ fontSize: 16, color: "red" }}
                      onClick={() => {
                        setVoucherCode("");
                        setVoucherValue(0);
                        setVoucherTxt("");
                      }}
                    />
                  )}
                </div>
              </div>
              {voucherTxt && (
                <div
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
              <Drawer
                title={
                  <div className="flex flex-col gap-4">
                    <div className="flex justify-between">
                      <span className="uppercase font-bold tex-[20px]">
                        {" "}
                        Mã giảm giá của tôi
                      </span>
                      <CloseOutlined
                        onClick={() => setOpenVoucher(false)}
                        style={{ fontSize: 18, cursor: "pointer" }}
                      />
                    </div>
                    <div>
                      {voucherTxt && (
                        <div
                          className="mt-4"
                          dangerouslySetInnerHTML={{ __html: voucherTxt }}
                        />
                      )}
                    </div>
                  </div>
                }
                placement={"bottom"}
                closable={false}
                onClose={() => setOpenVoucher(false)}
                open={openVoucher}
                height={"100%"}
                bodyStyle={{
                  background: "#f3f6f6",
                }}
              >
                <div className="p-4">
                  {vouchers.map((voucher) => (
                    <div
                      style={{
                        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                      }}
                      className=" rounded-[14px] bg-white p-3 mb-4"
                    >
                      <div className="flex gap-4 w-full">
                        {/* <div className="w-1/5 flex items-center justify-center">
                          <img
                            src="/images/ve-may-bay.svg"
                            className="w-[32px]"
                            alt=""
                          />
                        </div> */}
                        <div className="border-lime-300 border-1 flex flex-col gap-1 flex-1">
                          <div className="font-semibold text-[16px] text-primary">
                            {" "}
                            Mã {voucher.code}
                          </div>
                          <div className="text-red-600 text-[14px] font-bold">
                            {voucher.title}
                          </div>{" "}
                          <div className="text-[14px]">
                            Áp dụng từ{" "}
                            {dayjs(voucher.startDate).format(
                              "HH:mm DD/MM/YYYY"
                            )}{" "}
                            đến{" "}
                            {dayjs(voucher.endDate).format("HH:mm DD/MM/YYYY")}
                          </div>
                          <div
                            onClick={() => applyVoucherPick(voucher)}
                            className="text-primary font-medium text-[14px] ml-auto"
                          >
                            Áp dụng
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Drawer>
            </div>
            <div className="flex justify-center gap-4 mt-4">
              <Button
                className="bg-gray-100 text-white"
                size="large"
                onClick={() => setVisibleRecip(false)}
              >
                <span className="text-[16px]">Hủy</span>
              </Button>
              <Button
                onClick={() => {
                  handlePayment();
                }}
                type="primary"
                htmlType="sumit"
                size="large"
                loading={loading}
                className="mb-4 bg-primary"
              >
                <span className="text-[16px]">Thanh toán</span>
              </Button>
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default ElectricityWaterBill;
